import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {timeout} from 'rxjs/operators';
import {Configuration} from '@app/shared/models';
import {AppConfig} from '@app/shared/services';

@Injectable()
export class AngularInterceptor implements HttpInterceptor {
  private Config: Configuration;

  constructor() {
    this.Config = AppConfig.config;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(timeout(this.Config.timeoutRequestDelayed));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/http-interceptor.ts